import React from 'react';
import { motion } from 'framer-motion';
const DRA_LOGO = 'https://cdn.magicpatterns.com/uploads/wkgK3TfUfV2kt1gG4bGoYo/logo_Dra_Ysalismar.png';
const PROFEM_LOGO = 'https://cdn.magicpatterns.com/uploads/dVddGeVW64T3Smy2i85CP7/Logo_Centro_medico_Especializado_Profem.jpg';
export function SponsorEndorsement() {
  return <section className="px-4 pt-4 pb-10 bg-bg-primary" data-id="element-253">
      <div className="max-w-4xl mx-auto" data-id="element-254">
        <motion.div className="bg-white rounded-2xl p-6 md:p-8 shadow-md" style={{
        border: '1px solid #DCCFEA'
      }} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-255">
          <p className="text-center text-base md:text-lg font-semibold text-heading mb-6" data-id="element-256">
            ✅ Guía avalada y revisada por:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-10 items-center" data-id="element-257">
            {/* Dra. Ysailis */}
            <div className="flex flex-col items-center text-center" data-id="element-258">
              <div className="bg-white p-4 rounded-xl mb-3 h-28 flex items-center justify-center w-full" data-id="element-259">
                <img src={DRA_LOGO} alt="Dra. Ysailis Martínez" className="max-h-24 max-w-full object-contain" data-id="element-260" />
              </div>
              <p className="font-semibold text-heading" data-id="element-261">
                Dra. Ysailis Martinez
              </p>
              <a href="https://instagram.com/draysailismartinez" target="_blank" rel="noopener noreferrer" className="text-sm text-button hover:underline" data-id="element-262">
                📲 @draysailismartinez
              </a>
            </div>

            {/* Profem */}
            <div className="flex flex-col items-center text-center" data-id="element-263">
              <div className="bg-white p-4 rounded-xl mb-3 h-28 flex items-center justify-center w-full" data-id="element-264">
                <img src={PROFEM_LOGO} alt="Centro Médico Especializado Profem" className="max-h-24 max-w-full object-contain" data-id="element-265" />
              </div>
              <p className="font-semibold text-heading" data-id="element-266">
                Centro Médico Especializado Profem
              </p>
              <a href="https://instagram.com/profemm.ccs" target="_blank" rel="noopener noreferrer" className="text-sm text-button hover:underline" data-id="element-267">
                📲 @profemm.ccs
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}